import { render } from "./PaymentSuccess.vue?vue&type=template&id=0dccf604&scoped=true&ts=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts"

import "./PaymentSuccess.vue?vue&type=style&index=0&id=0dccf604&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dccf604"]])

export default __exports__